import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { HrButtons, HrFlexContainer, HrGridContainer, HrTitleH4 } from '@components/styles/hr-styles';
import { Input } from '@components/form/input';
import { EditorConvertToHTML } from '@components/text-editor/text-editor';
import { Modal } from '@/components/v1/Modal';

const getModalCopy = (entityType) => {
  if (entityType === 'client') {
    return {
      title: 'Crear cliente',
      primaryLabel: 'Guardar cliente'
    };
  }

  return {
    title: 'Crear área',
    primaryLabel: 'Guardar área'
  };
};

export const CreateAccountEntityModal = ({ entityType, isOpen, onClose, onSubmit, isSubmitting }) => {
  const { handleSubmit, register, formState, control, reset } = useForm({
    mode: 'all',
    defaultValues: {
      area: '',
      empresa: '',
      responsable: '',
      email: '',
      telefono: '',
      descripcion: ''
    }
  });

  const modalCopy = getModalCopy(entityType);

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleFormSubmit = async (data) => {
    const wasCreated = await onSubmit(data);
    if (wasCreated) {
      reset();
    }
  };

  return (
    <Modal isOpen={isOpen} toggleModal={handleClose} onClose={reset} topOffset={150}>
      <HrFlexContainer flexDirection='column' gap='12px'>
        <HrFlexContainer gap='4px' flexWrap='nowrap'>
          <i className='hr-Work-area' />
          <HrTitleH4>{modalCopy.title}</HrTitleH4>
        </HrFlexContainer>
      </HrFlexContainer>

      <HrGridContainer width='auto' margin='24px 0 0 0' columns='2'>
        <Input
          title={entityType === 'client' ? 'Cliente' : 'Área'}
          placeholder={entityType === 'client' ? 'Nombre del cliente' : 'Nombre del área'}
          name={entityType === 'client' ? 'empresa' : 'area'}
          type='text'
          register={register}
          formState={formState}
          validate={{
            required: true,
            maxLength: 50,
            minLength: 2,
            whiteSpace: true,
            caracterSpecialNew: true
          }}
        />
        <Input
          title='Responsable'
          placeholder='Nombre del responsable'
          name='responsable'
          type='text'
          register={register}
          formState={formState}
          validate={{
            required: true,
            maxLength: 50,
            minLength: 2,
            whiteSpace: true,
            caracterSpecialNew: true
          }}
        />
        <Input
          title='Email'
          placeholder='mail@empresa.com'
          name='email'
          type='text'
          register={register}
          formState={formState}
          validate={{
            required: true,
            maxLength: 200,
            mail: true,
            whiteSpace: true
          }}
        />
        <Input
          title='Telefono'
          placeholder='Telefono'
          name='telefono'
          type='text'
          register={register}
          formState={formState}
          validate={{
            required: false,
            maxLength: 20,
            minLength: 5,
            whiteSpace: true
          }}
        />
      </HrGridContainer>

      {entityType === 'client' && (
        <div style={{ marginTop: '24px' }}>
          <EditorConvertToHTML
            title='Descripcion de la empresa'
            validate={{ required: false }}
            formState={formState}
            control={control}
            id='descripcion'
            defVal=''
          />
        </div>
      )}

      <HrFlexContainer justifyContent='space-between' flexWrap='nowrap' padding='32px 0 0 0'>
        <HrButtons type='button' category='cancel' size='medium' onClick={handleClose} disabled={isSubmitting}>
          Cancelar
        </HrButtons>
        <HrButtons
          type='button'
          category='primary'
          size='medium'
          onClick={handleSubmit(handleFormSubmit)}
          disabled={isSubmitting}
        >
          {modalCopy.primaryLabel}
        </HrButtons>
      </HrFlexContainer>
    </Modal>
  );
};

CreateAccountEntityModal.propTypes = {
  entityType: PropTypes.oneOf(['area', 'client']).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool
};

CreateAccountEntityModal.defaultProps = {
  isSubmitting: false
};
